import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context9; _forEachInstanceProperty(_context9 = ownKeys(Object(source), true)).call(_context9, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context10; _forEachInstanceProperty(_context10 = ownKeys(Object(source))).call(_context10, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import { CONSUMERS, LISTS, ITEMS } from './constants';
import { get } from 'lodash';
/**
 * Add consumers to specific record / list
 * @param {Object} state
 * @param {string} id
 * @param {string} group
 * @param {string} consumerUuid
 */

function addConsumer(state, id, group, consumerUuid) {
  var _context, _context3;

  var currState = get(state, _concatInstanceProperty(_context = "".concat(group, ".")).call(_context, id));

  if (!currState) {
    var _context2;

    // Resource not loaded yet / doesn't exist
    console.warn(_concatInstanceProperty(_context2 = "Cannot consume ".concat(group, " with ID \"")).call(_context2, id, "\""));
    return state;
  }

  var currConsumers = currState[CONSUMERS] || [];

  if (_includesInstanceProperty(currConsumers).call(currConsumers, consumerUuid)) {
    // Already consuming this entity, so do nothing
    return state;
  }

  if (!_Array$isArray(consumerUuid)) {
    consumerUuid = [consumerUuid];
  }

  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, group, _objectSpread(_objectSpread({}, state[group]), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, currState), {}, _defineProperty({}, CONSUMERS, _concatInstanceProperty(_context3 = []).call(_context3, _toConsumableArray(currConsumers), _toConsumableArray(consumerUuid))))))));
}

export function addListConsumer(state, id, consumerUuid) {
  var _context4, _context5;

  var newState = addConsumer(state, id, LISTS, consumerUuid);
  var currListItems = get(state, _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = "".concat(LISTS, ".")).call(_context5, id, ".")).call(_context4, ITEMS));

  _forEachInstanceProperty(currListItems).call(currListItems, function (itemId) {
    newState = addConsumer(newState, itemId, ITEMS, consumerUuid);
  });

  return newState;
}
export function addItemConsumer(state, id, consumerUuid) {
  return addConsumer(state, id, ITEMS, consumerUuid);
}
/**
 * Removes a consumer from an item/a list. If the entity doesn't have any consumers
 * left, we garbage collect it here
 * @param  {Object} state
 * @param  {string} id
 * @param  {string} group
 * @param  {string} consumerUuid
 * @return {Object}
 */

function removeConsumer(state, id, group, consumerUuid) {
  var _context6, _context8;

  var currState = get(state, _concatInstanceProperty(_context6 = "".concat(group, ".")).call(_context6, id));

  if (!currState) {
    var _context7;

    console.warn(_concatInstanceProperty(_context7 = "Cannot remove consumer from ".concat(group, " with ID \"")).call(_context7, id, "\""));
  } // NOTE: temporarily disabled ... causes weird issues on errored entities
  // if (!currState || !currState[CONSUMERS].includes(consumerUuid)) {
  //   return state;
  // }


  currState[CONSUMERS] = _filterInstanceProperty(_context8 = _toConsumableArray(currState[CONSUMERS])).call(_context8, function (uuid) {
    return uuid && uuid !== consumerUuid;
  });
  state = _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, group, _objectSpread(_objectSpread({}, state[group]), {}, _defineProperty({}, id, _objectSpread({}, currState))))); // If there are no consumers left, remove the entry from
  //  the entity state, to clean up memory
  // TODO: we could try to implement some cache layer here,
  //  that takes x entities before clearing them completely?!
  // ALSO NOTE: as of now, created items will get thrown away
  //  as they won't have any immidiate consumer, TODO: find a
  //  good solution for this (how do we know where new items
  //  fit e.g. into lists?! We have to re-fetch, right? But
  //  what if we already loaded x pages? Etags as a standard
  //  would be really handy!)

  if (!currState[CONSUMERS].length) {
    // console.log(`🗑 ${group}: ${id}`);
    delete state[group][id];
  }

  return state;
}

export function removeListConsumer(state, id, consumerUuid) {
  return removeConsumer(state, id, LISTS, consumerUuid);
}
export function removeItemConsumer(state, id, consumerUuid) {
  return removeConsumer(state, id, ITEMS, consumerUuid);
}
/**
 * Removes consumer from all lists and items, which is usually what
 * we want when a consumer unregisters
 * @param  {Object} state
 * @param  {string} consumerUuid
 * @return {Object}
 */

export function removeConsumerAll(state, consumerUuid) {
  var listState = get(state, LISTS, {});
  var itemState = get(state, ITEMS, {});

  for (var id in listState) {
    if (id) {
      state = removeListConsumer(state, id, consumerUuid);
    }
  }

  for (var _id in itemState) {
    if (_id) {
      state = removeItemConsumer(state, _id, consumerUuid);
    }
  }

  return state;
}